import React from 'react';

const LoadingSpinner: React.FC = () => {
  return <div className="loading-spinner"></div>;
};

export default LoadingSpinner;